import { VApplication } from "../../../../../application";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { BlockListUserPageService } from "../../../../../services";

const MODULE_NAME = "profile.machines.states.getPage";
const log: any = LoggerModule?.getInstance();

const getSrv = () => {
  const app = VApplication.getInstance();
  return app.getSync(
    "services.BlockListUserPageService"
  ) as BlockListUserPageService;
};

export const delegatepage = async (context: any, event: any) => {
  const currentState = "GET_PAGE_CONTENT";
  const method = "getPageContent";

  return new Promise(async (resolve, reject) => {
    try {
      log.blue(MODULE_NAME, "context: ", context, "event: ", event);
      log.blue(MODULE_NAME, "context: ", context, "event: ", event);
      const _getArgs = () => {
        let _args: any = {};
        if (event?.type === "START") {
          _args = context["GET_PAGE_CONTENT"];
        }
        if (event?.type === "TRIGGER_REFRESH") {
          _args = {
            offset: event?.offset,
            size: event?.size,
            criteria: event?.criteria,
          };
        }
        console.log("getPageContent args =>", _args);
        return _args;
      };
      const srv = getSrv();
      const content = await srv.getPageContentdelegate(_getArgs());

      if (content) {
        return resolve({
          key: "RENDER_PAGE",
          value: {
            ...(content || {}),
          },
        });
      } else {
        const msg = "Page content not found";
        log.error(MODULE_NAME, `error in ${method}, msg: ${msg}`);
        return reject({
          key: "RENDER_PAGE_ERROR",
          value: msg,
        });
      }
    } catch (err: any) {
      log.error(MODULE_NAME, `error in ${method}, msg: ${err?.message}`);
      return reject({
        key: "RENDER_PAGE_ERROR",
        value: err?.message,
      });
    }
  });
};
